export const NOTIFY = 'NOTIFY'

export function notify(notification) {
  return {
    type: NOTIFY,
    notification
  }
}



// WEBPACK FOOTER //
// ./src/components/notifier/NotifierActions.js